export default __webpack_public_path__ + "assets/icons/notify1.53acc888.svg";